import React from 'react';
import Loader from '../../Components/Shared/Loader/loader';

const NoRoutes = ({ didCheckUser, context }) => {

    if (context.inProgress !== 'none' || !didCheckUser) return <Loader />

    return (
        <div className="container">
            <div className="d-flex justify-content-center">
                <div>
                    <img
                        src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/AccessDenied.jpg`}
                        alt="not found"
                        width={400}
                        height={400}
                    />
                </div>
                <div className="mt-5 pt-5">
                    <h3>
                        404 - Page not found
                    </h3>
                    <br />
                    Oops this is not the page you are looking for.
                    <br />
                </div>
            </div>
        </div>
    );
};

export default NoRoutes;
